import { render, staticRenderFns } from "./Target.vue?vue&type=template&id=03505f4e&scoped=true&"
import script from "./Target.vue?vue&type=script&lang=js&"
export * from "./Target.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03505f4e",
  null
  
)

export default component.exports